<template>
  <div class="maincen">
    <div class="catalog">
      <div class="catalogTit">个人资料</div>
    </div>
    <div class="userform">
      <el-form label-width="100px">
        <el-form-item label="教师姓名：">
            <span class="labelvalue commontext">{{ ruleForm.name }}</span>
          </el-form-item>
          <el-form-item label="工号：">
            <span class="labelvalue commontext">{{ ruleForm.jobNumber }}</span>
          </el-form-item>
          <el-form-item label="职称:">
            <span class="labelvalue commontext">{{
              getzhichengStr(ruleForm.professional)
            }}</span>
          </el-form-item>
          <el-form-item label="手机号:">
            <span class="labelvalue commontext">{{
              phoneStar(ruleForm.mobilephone)
            }}</span>
          </el-form-item>
          <el-form-item label="所属院系:">
            <span class="labelvalue commontext">{{
              ruleForm.facultyName
            }}</span></el-form-item
          >
          <el-form-item label="教师专业:">
            <span class="labelvalue commontext">{{
              ruleForm.specialtyName
            }}</span>
          </el-form-item>
          <el-form-item label="所教课程:">
            <template v-for="(item, index) in ruleForm.relationCourseVoList">
              <span
                v-if="index != ruleForm.relationCourseVoList.length - 1"
                class="labelvalue commontext"
                :key="index"
                >{{ item.courseName + ' / ' }}</span
              >
              <span
                v-if="index == ruleForm.relationCourseVoList.length - 1"
                class="labelvalue commontext"
                :key="index"
                >{{ item.courseName }}</span
              >
            </template>
          </el-form-item>
      </el-form>
    </div>
    <!-- <div class="center">
      <div class="content">
        <el-form
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm personForm"
        >
          <el-form-item label="教师姓名：">
            <span class="labelvalue commontext">{{ ruleForm.name }}</span>
          </el-form-item>
          <el-form-item label="工号：">
            <span class="labelvalue commontext">{{ ruleForm.jobNumber }}</span>
          </el-form-item>
          <el-form-item label="职称:">
            <span class="labelvalue commontext">{{
              getzhichengStr(ruleForm.professional)
            }}</span>
          </el-form-item>
          <el-form-item label="手机号:">
            <span class="labelvalue commontext">{{
              phoneStar(ruleForm.mobilephone)
            }}</span>
          </el-form-item>
          <el-form-item label="所属院系:">
            <span class="labelvalue commontext">{{
              ruleForm.facultyName
            }}</span></el-form-item
          >
          <el-form-item label="教师专业:">
            <span class="labelvalue commontext">{{
              ruleForm.specialtyName
            }}</span>
          </el-form-item>
          <el-form-item label="所教课程:">
            <template v-for="(item, index) in ruleForm.relationCourseVoList">
              <span
                v-if="index != ruleForm.relationCourseVoList.length - 1"
                class="labelvalue commontext"
                :key="index"
                >{{ item.courseName + ' / ' }}</span
              >
              <span
                v-if="index == ruleForm.relationCourseVoList.length - 1"
                class="labelvalue commontext"
                :key="index"
                >{{ item.courseName }}</span
              >
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div> -->
  </div>
</template>
<script>
import { getInfo } from '../../api/index'
import { getzhichengStr } from '../../assets/tool'
export default {
  data() {
    return {
      ruleForm: {},
      getzhichengStr: getzhichengStr,
    }
  },
  methods: {
    async getPersonData() {
      var res = await getInfo()
      this.ruleForm = res && res.data ? res.data : {}
    },
    phoneStar(val) {
      let returnVal = val
      if (val) {
        returnVal = val.substr(0, 3) + '****' + val.substr(7)
      }
      return returnVal
    },
  },
  created() {
    this.getPersonData()
  },
}
</script>
<style lang="scss" scoped>
.itemTit {
  font-size: 16px;
  color: #0082F0;
  margin: 17px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.userform /deep/.el-form-item__content{
  text-align: left !important;
  width: 420px;
  height: 40px;
  border: 1px solid #D5D5D5;
  border-radius: 4px;
  line-height: 40px;
  text-align: left;
  padding: 0px 20px;
  
}
.commontext{
  color: #333333;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.catalog{
  padding: 20px 0px 5px;
  border-bottom: 1px solid #e6e6e6;
}
.catalogTit{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.maincen{
  text-align: center;
  background-color: white;
  padding: 0px 20px;
}
.center{
  text-align: center;
}
.userform{
  padding: 50px 0px;
  margin: 0 auto;
  width: 520px;
  // background-color: rgb(255, 246, 246)
  
}
.formInput{
  width: 420px;
}
</style>
<style lang="scss">
@import '../../assets/css/centertabs.scss';
.personForm .el-form-item__error {
  margin-left: 100px;
}
</style>
